// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2kkez","content":"styles_content__3Zoya","selectAll":"styles_selectAll__3MYuH"};